export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="pt-32 pb-24 container mx-auto px-4 max-w-3xl">
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mb-6">Privacy Policy</h1>
      <div className="prose prose-zinc max-w-none">
        <p>This is a demo privacy policy for CFT Creations (Victinet IT Solutions Pvt. Ltd.). We collect minimal personal information needed to fulfil bookings, orders and inquiries.</p>
        <h3>Information we collect</h3>
        <ul><li>Name, email, phone for bookings & contact forms</li><li>Account credentials (hashed) when you register</li><li>Order/booking details</li></ul>
        <h3>How we use it</h3>
        <p>To fulfil services, communicate with you, and improve our offering. We never sell your data.</p>
        <h3>Contact</h3>
        <p>Email <a href="mailto:info@cftcreations.com">info@cftcreations.com</a> for any privacy questions.</p>
      </div>
    </div>
  );
}
